import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { CalendarEvent, CalendarEventTitleFormatter } from 'angular-calendar';
import moment from 'moment';
import 'moment/locale/fr';

@Injectable()
export class CustomEventTitleFormatter extends CalendarEventTitleFormatter {
  constructor(@Inject(LOCALE_ID) private readonly locale: string) {
    super();
  }

  week(event: CalendarEvent): string {
    return `<b>${
      moment(event.start).locale(this.locale).format('HH:mm') + (event.end ? ' - ' + moment(event.end).locale(this.locale).format('HH:mm') : '')
    }</b></br> ${event.title}`;
  }

  day(event: CalendarEvent): string {
    return this.week(event);
  }
}
